window.feeProductCart = async function () {
  return new Promise((resolve, reject) => {
    const fee_products = document.querySelectorAll('[data-fee-product-cart]');
    var data = {
      items: []
    };
    for (let index = 0; index < fee_products.length; index++) {
      var feeObject = {
        id: fee_products[index].value,
        quantity: document.getElementsByName("quantity")[0].value,
        properties: {
          Für: fee_products[index].getAttribute("data-product_title_cart"),
          main_id: fee_products[index].getAttribute("data-product_id_cart"),
        },
      };
      data.items.push(feeObject);
    }
    
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => {
        reject(error);
      });
  });
};

window.getNewCart = function () {
  return new Promise(function (resolve, reject) {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        if (data.item_count == 0) {
          localStorage.removeItem("FeeContent");
          return false;
        }
        sorted = [];
        data.items.forEach(function (item, index) {
          if (item.properties && "main_id" in item.properties && typeof item.properties.main_id !== "undefined") {
            sorted[item.id + "_" + item.properties.main_id] = {
              id: item.id,
              key: item.key,
              quantity: item.quantity,
            };
          }
        });
        localStorage.setItem("FeeContent", JSON.stringify(Object.assign({}, sorted)));
        resolve(JSON.parse(localStorage.getItem("FeeContent")));
      });
  });
};
window.getNewCart();
